import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // min-h-0 defeats the global tap-target min-height that otherwise
      // stretches this <button>-based control into a tall rectangle.
      'peer h-4 w-4 min-h-0 shrink-0 rounded-[var(--lc-radius-sm)] border border-[var(--lc-border-strong)]',
      'bg-[var(--lc-surface)] text-[var(--lc-action-primary-text)]',
      'focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
      'data-[state=checked]:border-[var(--lc-action-primary)] data-[state=checked]:bg-[var(--lc-action-primary)]',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
      <Check className="h-3 w-3" aria-hidden />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
